"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactReduxI18n = require("react-redux-i18n");

var _Icon = _interopRequireDefault(require("../Icon"));

var _jsxRuntime = require("react/jsx-runtime");

var UploadHeaderView = function UploadHeaderView(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex-container space-between col-12",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h2", {
      className: "flex-container m-0",
      children: [props.documentName, props.onDocumentExampleOpen && props.hasExample && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "clickable ml-3",
        "data-id": "document-example-tooltip",
        tooltip: _reactReduxI18n.I18n.t('document.seeExample'),
        style: {
          cursor: 'pointer'
        },
        onClick: props.onDocumentExampleOpen,
        flow: "bottom",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
          icon: "document-question",
          size: 18
        })
      })]
    }), props.children]
  });
};

UploadHeaderView.defaultProps = {
  hasExample: false
};
UploadHeaderView.propTypes = {
  documentName: _propTypes.default.string.isRequired,
  hasExample: _propTypes.default.bool,
  onDocumentExampleOpen: _propTypes.default.func,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
};
var _default = UploadHeaderView;
exports.default = _default;
//# sourceMappingURL=UploadHeaderView.js.map